var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShaira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136 104",
    style: {
      enableBackground: "new 0 0 136 104"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#1D1B22;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#A18071;}\r\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Head_x2F_Front_x2F_Long"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Hair-Back",
    className: "st0",
    d: "M95.8,31c3.6,13.2,8.2,42.8,3.4,47.5H69.1c0-0.1,0-0.1,0-0.2c-11.2-1.2-19.8-10.8-19.8-22.2 V34.4c0-12.3,10-22.3,22.3-22.3h2.1C84.9,12.1,94.1,20.2,95.8,31z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(54.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7,21c-4.8-5.6-8-12.5-7.5-20.2C1-21.4,31.9-16.5,38-5.3s5.3,39.6-2.5,41.7c-3.1,0.8-9.7-1.2-16.5-5.2 l4.2,29.9H-1.6L7,21z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Hair-Front",
    className: "st0",
    d: "M67.7,48.3C68.9,60.6,68.4,74.6,65,78H34.8c-1.6-29.1,14.6-17.9,14.6-45.3c1-1,2-2,2.9-2.8 v-0.8c5.2-10.8,11.8-16.1,19.8-16.1c12,0,15.8,5.6,19,10.4C88.8,31.7,79.4,33,71,38.1c-1-0.8-2.3-1.2-3.6-1.2 c-3.1,0-5.7,2.6-5.7,5.7c0,3.1,2.6,5.7,5.7,5.7C67.5,48.3,67.6,48.3,67.7,48.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShaira);
export default __webpack_public_path__ + "static/media/Shaira.dbca366e3d6e519edce90ddbc3be8751.svg";
export { ForwardRef as ReactComponent };